export const safetyTemplate = `
{% set reactionContent=reaction['$content'] %}
{% set reagents = safetyResult.filteredReagents %}
{% set report = safetyResult.report %}
{% set scores = safetyResult.report.scores %}
{% set miscellaneous = safetyResult.report.miscellaneous %}
{% set finalScore = safetyResult.finalScore %}

<style>
    #safetyReport body, #safetyReport tbody {
        font-family: arial, sans-serif;
    }
    #safetyReport .score {
        width: 60px;
        text-align: center;
    }
    #safetyReport .totalScore {
        width: 60px;
        text-align: center;
    }
    #safetyReport h1 {
        font-family: arial, sans-serif;
        padding-top: 1em;
        padding-bottom: 1em;
        text-align: center;
    }
    
    #safetyReport h2 {
        font-family: arial, sans-serif;
        padding-top: 0.5em;
        padding-bottom: 0.2em;
        margin-bottom: 0.5em;
        border-bottom: 1px solid black;
    }
    #safetyReport th {
        font-size: 1.2em;
    }
    #safetyReport .globalScore {
        font-size: 1.5em;
        text-align: center;
    }
    
    #safetyReport > table > tbody > tr:nth-child(even) {background: #DDD;}
    #safetyReport > table > tbody > tr:nth-child(odd) {background: #EEE}
    #safetyReport > table > tbody > tr:first-child {background: #CCC}
</style>


<div id="safetyReport">



<table style="width: 100%">
    <td>
		<img 
	        width="100" 
	        src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9 Im5vIj8+PHN2ZyB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRz LzEuMS8iIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMi IHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3lu dGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIg eG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEi IHZpZXdCb3g9IjAgMCAxODIuNCA1MyIgaGVpZ2h0PSI1MyIgd2lkdGg9IjE4Mi40 IiBkYXRhLW5hbWU9ImxvZ28gZXBmbCAyMDE5IiBpZD0ibG9nb19lcGZsXzIwMTki PiA8bWV0YWRhdGEgaWQ9Im1ldGFkYXRhMjciPiA8cmRmOlJERj4gPGNjOldvcmsg cmRmOmFib3V0PSIiPiA8ZGM6Zm9ybWF0PmltYWdlL3N2Zyt4bWw8L2RjOmZvcm1h dD4gPGRjOnR5cGUgcmRmOnJlc291cmNlPSJodHRwOi8vcHVybC5vcmcvZGMvZGNt aXR5cGUvU3RpbGxJbWFnZSIgLz4gPGRjOnRpdGxlPmVwZmwtbG9nby1uZXc8L2Rj OnRpdGxlPiA8L2NjOldvcms+IDwvcmRmOlJERj4gPC9tZXRhZGF0YT4gPGRlZnMg aWQ9ImRlZnM0Ij4gPHN0eWxlIGlkPSJzdHlsZTIiPi5jbHMtMXtmaWxsOnJlZDt9 PC9zdHlsZT4gPC9kZWZzPiA8dGl0bGUgaWQ9InRpdGxlNiI+ZXBmbC1sb2dvLW5l dzwvdGl0bGU+IDxwYXRoIGlkPSJwb2x5Z29uOCIgZD0iTSAwLDIxLjYgSCAxMS40 MyBWIDkuOCBIIDM4LjM0IFYgMCBIIDAgWiIgc3R5bGU9ImZpbGw6I2ZmMDAwMCIg Lz4gPHBhdGggaWQ9InBvbHlnb24xMCIgZD0iTSAwLDUzIEggMzguMzQgViA0My4y IEggMTEuNDMgViAzMS40IEggMCBaIiBzdHlsZT0iZmlsbDojZmYwMDAwIiAvPiA8 cGF0aCBpZD0icmVjdDEyIiBkPSJtIDExLjQzLDIxLjYgaCAyNC42MTAwMDEgdiA5 LjgwMDAwMSBIIDExLjQzIFoiIHN0eWxlPSJmaWxsOiNmZjAwMDAiIC8+IDxwYXRo IHN0eWxlPSJmaWxsOiNmZjAwMDAiIGlkPSJwYXRoMTQiIGQ9Ik04Niw0Ljg3YTE2 LjEyLDE2LjEyLDAsMCwwLTUuNjgtMy41M0EyMy43NiwyMy43NiwwLDAsMCw3MS44 MiwwSDQ4LjE0VjUzSDU5LjU3VjMxLjRINzEuODJhMjMuNzYsMjMuNzYsMCwwLDAs OC40Ni0xLjM0QTE2LjEyLDE2LjEyLDAsMCwwLDg2LDI2LjUzYTEzLjQzLDEzLjQz LDAsMCwwLDMuMTktNSwxNy4zOCwxNy4zOCwwLDAsMCwwLTExLjYyQTEzLjUyLDEz LjUyLDAsMCwwLDg2LDQuODdaTTc4LDE4LjczYTUuNyw1LjcsMCwwLDEtMi4yNiwx LjgsMTEuMzMsMTEuMzMsMCwwLDEtMy4yNy44NSwzMiwzMiwwLDAsMS0zLjg2LjIy SDU5LjU3VjkuOGg5LjA1YTMyLDMyLDAsMCwxLDMuODYuMjIsMTEsMTEsMCwwLDEs My4yNy44NkE1LjU5LDUuNTksMCwwLDEsNzgsMTIuNjdhNSw1LDAsMCwxLC44Niwz QTUsNSwwLDAsMSw3OCwxOC43M1oiIGNsYXNzPSJjbHMtMSIgLz4gPHBhdGggaWQ9 InBvbHlnb24xNiIgZD0iTSAxNTUuNDcsNDMuMiBWIDAgaCAtMTEuNDMgdiA1MyBo IDM4LjM0IHYgLTkuOCB6IiBzdHlsZT0iZmlsbDojZmYwMDAwIiAvPiA8cGF0aCBp ZD0icG9seWdvbjE4IiBkPSJtIDk3LjQyLDIxLjYgaCAxMS40MyBWIDkuOCBoIDI2 LjkxIFYgMCBIIDk3LjQyIFoiIHN0eWxlPSJmaWxsOiNmZjAwMDAiIC8+IDxwYXRo IGlkPSJyZWN0MjAiIGQ9Ik0gOTcuNDE5OTk4LDMxLjQgSCAxMDguODUgViA1MyBI IDk3LjQxOTk5OCBaIiBzdHlsZT0iZmlsbDojZmYwMDAwIiAvPiA8cGF0aCBpZD0i cmVjdDIyIiBkPSJtIDEwOC44NSwyMS42IGggMjQuNjEgdiA5LjgwMDAwMSBoIC0y NC42MSB6IiBzdHlsZT0iZmlsbDojZmYwMDAwIiAvPjwvc3ZnPg=="
	    >
    </td>
    <td style="font-size: 2em; text-align: center">
        Laboratory of Sustainable and Catalytic Processing
    </td>
    <td>
        EPFL SB ISIC LPDC<br>
        Station 6<br>
        CH-1015, Lausanne<br>
        https://www.epfl.ch/labs/lpdc/
    </td>
</table>

<h1>
    Lab Procedure assessment
</h1>

<center>
<h1>{{rendertype(reactionContent.title)}}</h1>

{{rendertype(reactionContent.reactionRXN,'rxn')}}
</center>

<h2>Reagents</h2>

<table style="width: 100%">
<tr>
    <th>Name</th>
    <th>Quantity</th>
    <th>Pictograms</th>
    <th>Hazards</th>
</tr>
{% for reagent in reagents %}
<tr>
    <td>{{reagent.iupac}}</td>
    <td>{{reagent.g}} g</td>
    <td>
            {% if reagent.pictograms %}
            <div>
                {{rendertypeBlock(reagent.pictograms,{height:'25px'},'ghs')}}
            </div>
            {% endif %}
    </td>
    <td width=200>
        {% for hazard in reagent.hazards %}
            {{hazard}}
        {% endfor %}
    </td>
</tr>
{% endfor %}
</table>

<h2>Volume & Flammability</h2>

<table style="width: 100%">
    <tr>
        <th>Name</th>
        <th>Description</th>
        <th>Matching hazards</th>
        <th class="score">Score</th>
        <th class="totalScore">Total</th>
    </tr>
{% for reagent in reagents %}
<tr>
    <td>{{reagent.iupac}}</td>
    <td>{{reagent.safety.volumeAndFlammability.description}}</td>
    <td>
        {% for hazard in reagent.safety.volumeAndFlammability.matchingHazards %}
          {{hazard}}
        {% endfor %}
    </td>
    <td class="score">{{reagent.safety.volumeAndFlammability.score}}</td>
    {% if loop.first %}
        <td class="globalScore" rowspan={{loop.length}}>{{scores.volumeAndFlammability}}</td>
    {% endif %}
</tr>
{% endfor %}
</table>

<h2>Reactivity / Instability</h2>

<table style="width: 100%">
    <tr>
        <th>Name</th>
        <th>Matching hazards</th>
        <th class="score">Score</th>
        <th class="totalScore">Total</th>
    </tr>
    {% for reagent in reagents %}
        <tr>
            <td>{{reagent.iupac}}</td>
            <td colspan=2>
                <table style="width: 100%">
                    {% for reactivityAndInstability in reagent.safety.reactivityAndInstabilities %}
                    <tr>
                            <td>
                                {% for hazard in reactivityAndInstability.matchingHazards %}
                                  {{hazard}}
                                {% endfor %}
                            </td>
                            <td>{{reactivityAndInstability.description}}</td>
        
                            <td class="score">{{reactivityAndInstability.score}}</td>
                    </tr>
                    {% endfor %}
                </table>
            </td>
            {% if loop.first %}
                <td class="globalScore" rowspan={{loop.length}}>{{scores.reactivityAndInstability}}</td>
            {% endif %}
        </tr>
    {% endfor %}
    </table>

<h2>Acute toxicity</h2>

<table style="width: 100%">
    <tr>
        <th>Name</th>
        <th>Description</th>
        <th>Matching hazards</th>
        <th class="score">Score</th>
        <th class="totalScore">Total</th>
    </tr>
    {% for reagent in reagents %}
        <tr>
            <td>{{reagent.iupac}}</td>
            <td>{{reagent.safety.acuteToxicity.description}}</td>
            <td>
                {% for hazard in reagent.safety.acuteToxicity.matchingHazards %}
                  {{hazard}}
                {% endfor %}
            </td>
            <td class="score">{{reagent.safety.acuteToxicity.score}}</td>
            {% if loop.first %}
                <td class="globalScore" rowspan={{loop.length}}>{{scores.acuteToxicity}}</td>
            {% endif %}
        </tr>
    {% endfor %}
    </table>

<h2>Long-term toxicity</h2>
    <table style="width: 100%">
    <tr>
        <th>Name</th>
        <th>Description</th>
        <th>Matching hazards</th>
        <th class="score">Score</th>
        <th class="totalScore">Total</th>
    </tr>
    {% for reagent in reagents %}
        <tr>
            <td>{{reagent.iupac}}</td>
            <td>{{reagent.safety.longTermToxicity.description}}</td>
            <td>
                {% for hazard in reagent.safety.longTermToxicity.matchingHazards %}
                  {{hazard}}
                {% endfor %}
            </td>
            <td class="score">{{reagent.safety.longTermToxicity.score}}</td>
            {% if loop.first %}
                <td class="globalScore" rowspan={{loop.length}}>{{scores.longTermToxicity}}</td>
            {% endif %}
        </tr>
    {% endfor %}
    </table>
    
<h2>Miscellaneous</h2>

   <table style="width: 100%">
    <tr>
        <th style="width: 200px">Label</th>
        <th>Details</th>
        <th class="score">Score</th>
        <th class="totalScore">Total</th>
    </tr>
    {% for misc in miscellaneous %}
    <tr>
        <td><b>{{misc.label}}</b><br><i>{{misc.info}}</br></i></td>
        <td colspan=2>
            <table style="width: 100%">
                {% for score in misc.scores%}
                    <tr>
                        <td>
                            {{score.remarks}} 
                            {{score.description}}
                        </td>
                        <td width="100px">
                            {{score.label}}
                        </td>
                        <td class="score">
                            {{score.score}}
                        </td>
                    </tr>
                {% endfor %}
            </table>
        </td>
        <td class="globalScore">{{misc.score}}</td>
    </tr>
    {% endfor %}
    </table>

{% if report.redAcuteToxicity.length>0 %}
  <p style="font-size: 1.5em; color: red; font-weight: bold;">
  Red acute toxicities: 
  {% for toxicity in report.redAcuteToxicity %}
    {{toxicity}}
  {% endfor %}
  </p>
{% endif %}

{% if report.redReactivityAndInstabilities.length>0 %}
  <p style="font-size: 1.5em; color: red; font-weight: bold;">
  Red reactivity and instabilities: 
  {% for instability in report.redReactivityAndInstabilities %}
    {{instability}}
  {% endfor %}
  </p>
{% endif %}


<div style="font-size: 1.5em; font-weight: bold; text-align: right">Final score: {{report.finalScore}}</div>

<div style="break-inside: avoid; font-size: 2em; border: black solid 2px; padding: 10px; margin: 10px">

{% if report.errors.length>0 %}
    <div style="background-color: pink">
    <b>Need to fix {{report.errors.length}} error(s):</b>
    <ul>
        {% for error in report.errors %}
            <li>{{error.message}}</li>
        {% endfor %}
    </ul>
    </div>
    
{% endif %}


{% if report.class==1 %}
<p style="margin-bottom: 10px">
   <b>Class 1:</b> Score =< 12 points, no red H statements = Auto-control  
</p>
 	<p>Action: Auto control. If you suspect any risk, consult COSEC for verification.</p>
{% endif %}

{% if report.class==2 %}
<p style="margin-bottom: 10px">
    <b>Class 2:</b> Score > 12 points or Score < 12 points with red H statement
</p>
 	<p>Action: Mandatory Standard Operating Procedure (SOP). The SOP must be reviewed by COSEC. Consider possible alternatives (e.g., scaling down, using different chemicals). Print and display the SOP on the fume hood and lab door. Do not proceed with the experiment until the signed SOP is obtained.</p>
{% endif %}

{% if report.class==3 %}
<p style="margin-bottom: 10px">
    <b>Class 3:</b> Score > 18 points
</p>
 	<p>Action: Consider possible alternatives before proceeding. The SOP must be reviewed by both COSEC and the PI. Print and display the SOP on the fume hood and lab door. Do not conduct the experiment without a signed SOP. The PI and COSEC will determine if an OHS review is required.</p>
{% endif %}
{% if report.class==4 %}
<p style="margin-bottom: 10px">
    <b>Class 4:</b> Forbidden
</p>
    <p>Do not perform the experiment.</p>
{% endif %}
</div>

</div>
`;
